import {registerComponent, registerDirective, registerPlugin} from '@/appManager';
import directiveOverflowCheck from "@/vue/directives/directive-overflow-check";
import {CardPlugin, CollapsePlugin} from "bootstrap-vue";
import VModal from "vue-js-modal";

export function registerVueComponents() {


    // account
    registerComponent('A4Orders', () => import(/* webpackChunkName: "v_account_order" */  '@/vue/components/account/A4-Orders.vue'));


    // checkout
    registerComponent('A4Checkout', () => import(/* webpackChunkName: "v_checkout" */ '@/vue/components/checkout/A4-Checkout.vue'));
    registerComponent('A4CheckoutOrder', () => import(/* webpackChunkName: "v_checkout" */ '@/vue/components/checkout/A4-Checkout-Order.vue'));
    registerComponent('A4CheckoutForm', () => import(/* webpackChunkName: "v_checkout" */ '@/vue/components/checkout/A4-Checkout-Form.vue'));
    registerComponent('A4CheckoutLogin', () => import(/* webpackChunkName: "v_checkout" */ '@/vue/components/checkout/A4-Checkout-Login.vue'));


    // form
    registerComponent('A4Form', () => import(/* webpackChunkName: "v_form" */ '@/vue/components/form/A4-Form.vue'));

    registerComponent('a4FormInputNumber', () => import(/* webpackChunkName: "v_form-el" */ '@/vue/components/form/A4-Form-Input-Number.vue'));
    registerComponent('a4FormInputText', () => import(/* webpackChunkName: "v_form-el" */ '@/vue/components/form/A4-Form-Input-Text.vue'));
    registerComponent('a4FormInputRadio', () => import(/* webpackChunkName: "v_form-el" */ '@/vue/components/form/A4-Form-Input-Radio.vue'));
    registerComponent('a4FormInputSelect', () => import(/* webpackChunkName: "v_form-el" */ '@/vue/components/form/A4-Form-Input-Select.vue'));
    registerComponent('a4FormTextarea', () => import(/* webpackChunkName: "v_form-el" */ '@/vue/components/form/A4-Form-Textarea.vue'));
    registerComponent('a4RadioCheckerCustom', () => import(/* webpackChunkName: "v_form-el" */ '@/vue/components/europlan/A4RadioCheckerCustom.vue'));

    // form components with plugin dependencies
    registerComponent('A4FormInputDate', () => import(/* webpackChunkName: "v_form-date" */ '@/vue/components/form/A4-Form-Input-Date.vue'));
    registerComponent('A4FormFilepond', () => import(/* webpackChunkName: "v_form-file" */ '@/vue/components/form/A4-Form-FilePond.vue'));

    // not a real form component = button to trigger modal (used in a form component)
    registerComponent('a4FormInputActions', () => import(/* webpackChunkName: "v_form-el" */ '@/vue/components/form/A4-Form-Input-Actions.vue'));


    // order
    registerComponent('A4OrderUpdate', () => import(/* webpackChunkName: "v_order_update" */ '@/vue/components/orders/A4-Order-Update.vue'));
    registerComponent('A4OrderItemUpdateForm', () => import(/* webpackChunkName: "v_order_update" */ '@/vue/components/orders/A4-Order-Item-Update-Form.vue'));


    // Product Price bar + scale
    registerComponent('A4ConfiguratorPriceBar', () => import(/* webpackChunkName: "v_price-scale" */ '@/vue/components/configurator/A4ConfiguratorPriceBar.vue'));
    registerComponent('A4ConfiguratorPriceScale', () => import(/* webpackChunkName: "v_price-scale" */ '@/vue/components/configurator/PriceScale/A4ConfiguratorPriceScale.vue'));
    registerComponent('A4ConfiguratorPricetableRow', () => import(/* webpackChunkName: "v_price-scale" */ '@/vue/components/configurator/PriceScale/A4ConfiguratorPricetableRow.vue'));
    registerComponent('A4ConfiguratorPricetableRowCustom', () => import(/* webpackChunkName: "v_price-scale" */ '@/vue/components/configurator/PriceScale/A4ConfiguratorPricetableRowCustom.vue'));

    // Product Configuration Main + Navigation
    registerComponent('a4CfWithSteps', () => import(/* webpackChunkName: "v_cf" */ '@/vue/components/configurator/A4-Cf-With-Steps.vue'));
    registerComponent('A4CfStepsNavigationNode', () => import(/* webpackChunkName: "v_cf" */ '@/vue/components/configurator/ConfigurationSteps/A4-Cf-Steps-Navigation-Node.vue'));
    registerComponent('A4CfStepsNode', () => import(/* webpackChunkName: "v_cf" */ '@/vue/components/configurator/ConfigurationSteps/A4-Cf-Steps-Node.vue'));
    registerComponent('a4CfStepsSection', () => import(/* webpackChunkName: "v_cf" */ '@/vue/components/configurator/ConfigurationSteps/A4-Cf-Steps-Section.vue'));
    registerComponent('a4CfStepsGroup', () => import(/* webpackChunkName: "v_cf" */ '@/vue/components/configurator/ConfigurationSteps/A4-Cf-Steps-Group.vue'));
    registerComponent('a4CfStepsStep', () => import(/* webpackChunkName: "v_cf" */ '@/vue/components/configurator/ConfigurationSteps/A4-Cf-Steps-Step.vue'));

    // Product Configuration nodes and parts
    registerComponent('a4CfNode', () => import(/* webpackChunkName: "v_cf-node" */ '@/vue/components/configurator/Nodes/A4-Cf-Node.vue'));
    registerComponent('A4CfNodeItem', () => import(/* webpackChunkName: "v_cf-node" */ '@/vue/components/configurator/Nodes/A4-Cf-Node-Item.vue'));
    registerComponent('a4CfOption', () => import(/* webpackChunkName: "v_cf-node" */ '@/vue/components/configurator/Nodes/A4-Cf-Option.vue'));
    registerComponent('a4CfOptionvalue', () => import(/* webpackChunkName: "v_cf-node" */ '@/vue/components/configurator/Nodes/A4-Cf-Optionvalue.vue'));
    registerComponent('a4CfInputChecker', () => import(/* webpackChunkName: "v_cf-node" */ '@/vue/components/configurator/Nodes/Parts/A4-Cf-Input-Checker.vue'));
    registerComponent('A4CfInputDimensions', () => import(/* webpackChunkName: "v_cf-node" */ '@/vue/components/configurator/Nodes/Parts/A4-Cf-Input-Dimensions.vue'));
    registerComponent('A4CfInputDimension', () => import(/* webpackChunkName: "v_cf-node" */ '@/vue/components/configurator/Nodes/Parts/A4-Cf-Input-Dimension.vue'));
    registerComponent('A4CfNodeInputObjects', () => import(/* webpackChunkName: "v_cf-node" */ '@/vue/components/configurator/Nodes/Parts/A4-Cf-Node-Input-Objects.vue'));
    registerComponent('A4CfPriceInfo', () => import(/* webpackChunkName: "v_cf-node" */ '@/vue/components/configurator/Nodes/Parts/A4-Cf-PriceInfo.vue'));
    registerComponent('A4CfInputSwatch', () => import(/* webpackChunkName: "v_cf-node" */ '@/vue/components/configurator/Nodes/Parts/A4-Cf-Input-Swatch.vue'));

    // Product Configuration Tools
    registerComponent('A4ConfiguratorCheck', () => import(/* webpackChunkName: "v_cf-check" */ '@/vue/components/configurator/A4-Configurator-Check.vue'));


    // Settings
    registerComponent('A4SettingsManager', () => import(/* webpackChunkName: "v_settings" */ '@/vue/components/settings/A4-Settings-Manager.vue'));
    registerComponent('A4ToggleVat', () => import(/* webpackChunkName: "v_settings" */ '@/vue/components/settings/A4-Toggle-Vat.vue'));
    registerComponent('A4ToggleShipping', () => import(/* webpackChunkName: "v_settings" */ '@/vue/components/settings/A4-Toggle-Shipping.vue'));


    // Swatches
    registerComponent('a4CfSwatchPicker', () => import(/* webpackChunkName: "v_swatch" */ '@/vue/components/configurator/Nodes/Parts/A4-Cf-SwatchPicker.vue'));
    registerComponent('a4SwatchSelector', () => import(/* webpackChunkName: "v_swatch" */ '@/vue/components/europlan/A4SwatchSelector.vue'));
    registerComponent('a4SwatchSelectorModal', () => import(/* webpackChunkName: "v_swatch" */ '@/vue/components/configurator/A4SwatchSelectorModal.vue'));


    // UI plugins
    registerPlugin(CollapsePlugin); //// still needed ?
    registerPlugin(CardPlugin); //// still needed ?

    // UI components
    registerComponent('A4Button', () => import(/* webpackChunkName: "v_ui_core" */ '@/vue/components/europlan/A4-Button.vue'));
    // registerComponent('a4CollapsibleContainer', () => import('@/vue/components/europlan/A4-Collapsible-Container.vue'));
    registerComponent('a4ExtendableLabel', () => import(/* webpackChunkName: "v_ui_core" */ '@/vue/components/europlan/A4-Extendable-Label.vue'));
    registerComponent('a4KeyValueBlock', () => import(/* webpackChunkName: "v_ui_core" */ '@/vue/components/europlan/A4KeyValueBlock.vue'));
    registerComponent('a4MessageBox', () => import(/* webpackChunkName: "v_ui_core" */ '@/vue/components/europlan/A4-MessageBox.vue'));
    registerComponent('a4ToggleHint', () => import(/* webpackChunkName: "v_ui_core" */ '@/vue/components/europlan/A4ToggleHint.vue'));
    registerComponent('a4SvgFromSpritemap', () => import(/* webpackChunkName: "v_ui_core" */ '@/vue/components/europlan/A4SvgFromSpritemap.vue'));

    // UI - Modals
    /**
     * Make Bootstrap Native Modal available everywhere, including in Vue
     * @param id
     * @param show
     */
    window.showModal = function (id, show = true) {
        const modalEl = document.getElementById(id);
        if (modalEl && typeof BSN !== 'undefined' && BSN.Modal) {
            let modalInstance = new BSN.Modal(modalEl, {
                backdrop: true
            });
            show ? modalInstance.show() : modalInstance.hide();
        } else {
            console.warn(`Modal with id "${id}" not found or Bootstrap Native not loaded`);
        }
    };
    registerPlugin(VModal);
    registerComponent('a4ControllerModal', () => import(/* webpackChunkName: "v_modal" */ '@/vue/components/europlan/A4ControllerModal.vue'));
    registerComponent('a4Modal', () => import(/* webpackChunkName: "v_modal" */ '@/vue/components/europlan/A4Modal.vue'));

    // UI - directives
    registerDirective('check-overflow', directiveOverflowCheck);
}
